import { render, staticRenderFns } from "./look-share.vue?vue&type=template&id=c2bad22a&scoped=true&"
import script from "./look-share.vue?vue&type=script&lang=js&"
export * from "./look-share.vue?vue&type=script&lang=js&"
import style0 from "./look-share.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./look-share.vue?vue&type=style&index=1&id=c2bad22a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2bad22a",
  null
  
)

export default component.exports